import { motion } from "framer-motion";

export function AnimatedBackground() {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none bg-background">
      {/* Animated gradient blobs */}
      <motion.div
        className="absolute -top-40 -left-40 w-[55vw] h-[55vw] rounded-full opacity-[0.18] blur-[120px]"
        style={{ background: "radial-gradient(circle, oklch(0.92 0.20 105) 0%, transparent 70%)" }}
        animate={{
          x: [0, 120, -60, 0],
          y: [0, 80, 160, 0],
          scale: [1, 1.15, 0.95, 1],
        }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute top-1/3 -right-40 w-[50vw] h-[50vw] rounded-full opacity-[0.14] blur-[120px]"
        style={{ background: "radial-gradient(circle, oklch(0.96 0.21 100) 0%, transparent 70%)" }}
        animate={{
          x: [0, -100, 60, 0],
          y: [0, 120, -80, 0],
          scale: [1, 0.9, 1.2, 1],
        }}
        transition={{ duration: 26, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.div
        className="absolute bottom-0 left-1/3 w-[45vw] h-[45vw] rounded-full opacity-[0.12] blur-[120px]"
        style={{ background: "radial-gradient(circle, oklch(0.92 0.20 105) 0%, transparent 70%)" }}
        animate={{
          x: [0, 80, -120, 0],
          y: [0, -100, 60, 0],
          scale: [1, 1.1, 0.85, 1],
        }}
        transition={{ duration: 30, repeat: Infinity, ease: "easeInOut" }}
      />

      {/* Subtle moving grid */}
      <motion.div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(oklch(0.92 0.20 105) 1px, transparent 1px), linear-gradient(90deg, oklch(0.92 0.20 105) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
        animate={{ backgroundPosition: ["0px 0px", "60px 60px"] }}
        transition={{ duration: 18, repeat: Infinity, ease: "linear" }}
      />

      {/* Floating sparks */}
      {Array.from({ length: 14 }).map((_, i) => (
        <motion.span
          key={i}
          className="absolute w-1 h-1 rounded-full bg-primary"
          style={{
            top: `${(i * 73) % 100}%`,
            left: `${(i * 47) % 100}%`,
            boxShadow: "0 0 8px var(--primary)",
          }}
          animate={{
            y: [0, -40, 0],
            opacity: [0, 0.8, 0],
          }}
          transition={{
            duration: 4 + (i % 5),
            repeat: Infinity,
            delay: i * 0.4,
            ease: "easeInOut",
          }}
        />
      ))}

      {/* Vignette */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, transparent 30%, oklch(0.08 0 0 / 0.6) 100%)",
        }}
      />
    </div>
  );
}
